module.exports = __webpack_public_path__ + "static/media/saludablemente.cbb9c77e.jpg";